import React, { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { styled } from 'styled-components';

import { Case } from '../../../../shared/api/hscan/case';
import maximizeIcon from '../../assets/icons/icon_maximize.svg';
import { ButtonWithIcon } from '../../common/components/ButtonWithIcon';
import { DetailButton } from '../../common/components/ImageDetailButton';
import { WindowSize, WindowSizeContext } from '../../hooks/windowSizeHook';
import { isMobile as detectMobile } from '../../utils';

import { MaxImageModal } from './MaxImageModal';

const ButtonWrapper = styled.div`
  display: flex;
  align-self: flex-end;
  margin-top: 16px;
  column-gap: 10px;
  row-gap: 8px;

  ${p =>
    p.theme.isMobile &&
    `
    column-gap: 3px;
    font-size: 12px;
    `}
`;

interface ImageDetailButtonsProps {
  caseInfo: Case;
}
export const ImageDetailButtons = (props: ImageDetailButtonsProps) => {
  const { caseInfo } = props;
  const { t } = useTranslation('translation', {
    keyPrefix: 'features.imageList.imageDetails',
  });

  const windowSize = useContext(WindowSizeContext);
  const isMobile = windowSize === WindowSize.MOBILE;

  const [openModal, setOpenModal] = useState(false);

  const isMobileDevice = detectMobile();

  return (
    <ButtonWrapper>
      {!isMobileDevice && <DetailButton caseInfo={caseInfo} />}
      <ButtonWithIcon
        $padding="5px"
        $fontSize={isMobile ? '12px' : undefined}
        icon={maximizeIcon}
        text={`${t('maximizeButton')}`}
        onClick={() => setOpenModal(true)}
      />
      <MaxImageModal
        open={openModal}
        onClose={() => setOpenModal(false)}
        caseInfo={caseInfo}
      />
    </ButtonWrapper>
  );
};
